import { useMutation } from '@tanstack/react-query';

import { venueUpdateVenueApi } from '../../api/venue/venueUpdateVenueApi';

type Props = {
  onSuccess?: () => void;
};

export const useVenueUpdateVenueMutation = ({ onSuccess }: Props) => {
  const venueUpdateMutation = useMutation({
    mutationFn: venueUpdateVenueApi,
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
  });

  return venueUpdateMutation;
};
